(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').directive('mxSearchQueryCondition', [
		function mxSearchQueryConditionDirective() {
			MxSearchQueryConditionCtrl.$inject = [
				'$rootScope',
				'$compile',
				'$element',
				'$scope',
				'mx.SolutionBuilderAgent.SearchQueryService',
				'mx.sb.Agent.DataQuery.FilterOperatorsFactory',
			];

			function MxSearchQueryConditionCtrl($rootScope, $compile, $element, $scope, searchQueryService, filterOperatorsFactory) {
				var vm = this;
				var directive = '';
				var watchers = [];
				const operators = filterOperatorsFactory.operators;
				vm.remove = remove;
				vm.toggleParentLogicalOperator = toggleParentLogicalOperator;
				vm.toggleExpanded = toggleExpanded;

				vm.$onInit = function () {
					vm.expanded = !vm.readOnly;
					vm.operators = [];
					vm.conditionString = '';
					vm.isExpression = vm.condition.type === 'Expression';

					if (vm.condition.__property && vm.condition.__property.ReferenceTo) {
						if (vm.condition.__enumeration) {
							directive = 'mx-search-query-condition-enum-reference';
							vm.operators = filterOperatorsFactory.getOperatorsByType('EnumReference');
						} else {
							directive = 'mx-search-query-condition-object-reference';
							vm.operators = filterOperatorsFactory.getOperatorsByType('ObjectReference');
						}

						if (!_.find(vm.operators, ['value', vm.condition.operator])) {
							vm.condition.operator = operators.In.value;
						}
					} else {
						switch (vm.condition.type) {
							case 'BoolType':
								directive = 'mx-search-query-condition-boolean';
								break;

							case 'IntType':
							case 'DecimalType':
								vm.operators = getOperators(vm.condition.type);
								directive = 'mx-search-query-condition-decimal';
								break;

							case 'FloatType':
							case 'Currency':
								vm.operators = getOperators(vm.condition.type);
								directive = 'mx-search-query-condition-float';
								break;

							case 'DateType':
								vm.operators = getOperators(vm.condition.type);
								directive = 'mx-search-query-condition-date';

								if (vm.condition.operator === operators.Equals.value) {
									vm.condition.operator = operators.Between.value;
								}
								break;

							case 'Expression':
								directive = 'mx-search-query-condition-expression';
								vm.operators = filterOperatorsFactory.getOperatorsByType('Expression');
								break;

							// Case 'StringType':
							default:
								vm.operators = getOperators(vm.condition.type);
								directive = 'mx-search-query-condition-string';
								break;
						}
					}

					if (directive) {
						initCondition(directive);
					}
				};

				watchers.push($scope.$watchCollection('vm.condition.value', updateCondition));
				watchers.push($scope.$watch('vm.condition.valueString', updateCondition));
				watchers.push($scope.$watch('vm.condition.operator', updateCondition));

				$scope.$on('$destroy', function () {
					watchers.forEach((w) => w());
					watchers = [];
				});

				return vm;

				function getOperators(conditionType) {
					var type = _.findKey(mx.shell.ObjectPropertyType, ['name', conditionType]);

					return type ? filterOperatorsFactory.getOperatorsByType(type) : [];
				}

				function initCondition(directive) {
					var itemScope = $rootScope.$new();
					watchers.push(function () {
						itemScope.$destroy();
					});

					itemScope.condition = vm.condition;
					itemScope.operators = filterOperatorsFactory.operators;
					itemScope.className = vm.className;
					var el = $compile(`<${directive} condition="condition" operators="operators" class-name="{{className}}"></${directive}>`)(itemScope);

					angular.element($element[0].querySelector('.mx-search-condition--body')).append(el);
				}

				function remove() {
					if (vm.parent) {
						vm.parent.removeCondition(vm.condition.id);
						if (vm.onRemove) {
							vm.onRemove({ condition: vm.condition });
						}
					}
				}

				function toggleExpanded() {
					if (vm.readOnly) {
						return;
					}
					vm.condition.__expanded = !vm.condition.__expanded;
				}

				function toggleParentLogicalOperator(event) {
					if (event) {
						event.stopPropagation();
					}
					vm.parent.logicalOperator =
						vm.parent.logicalOperator === mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND
							? mx.SolutionBuilderAgent.SearchQueryLogicalOperator.OR
							: mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND;
				}

				function updateCondition() {
					vm.conditionString = searchQueryService.getConditionString(vm.condition);
					vm.operatorInfo = vm.operators.filter(function (op) {
						return op && op.value === vm.condition.operator;
					})[0];
					vm.condition.__expanded = !vm.readOnly;
					if (vm.condition.operator === operators.IsNotSet.value || vm.condition.operator === operators.IsSet.value) {
						vm.condition.value = [];
						vm.condition.__valid = true;
					}
				}
			}

			return {
				restrict: 'E',
				scope: {},
				replace: true,
				bindToController: {
					condition: '=',
					parent: '=',
					className: '@',
					onRemove: '&',
					readOnly: '<?',
				},
				controller: MxSearchQueryConditionCtrl,
				controllerAs: 'vm',
				templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/mx-search-query-condition.html',
			};
		},
	]);
})();
